import {
  Textarea,
  UseDisclosureProps,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { FC, useRef } from 'react';
import {
  useGetCaptainsMessage,
  useUpdateCaptainsMessage,
} from '@frx/frx-react-context';
import isEmpty from 'lodash/fp/isEmpty';
import { Modal, Notification } from '../../../../components';
import { useEventId } from '../../../../hooks';

export type AnnouncementProps = Required<
  Pick<UseDisclosureProps, 'isOpen' | 'onClose'>
>;

export const Announcement: FC<AnnouncementProps> = ({ isOpen, onClose }) => {
  const teamAnnouncementInputRef = useRef<HTMLTextAreaElement>(null);
  const toast = useToast();
  const eventId = useEventId();
  const captainsMessageData = useGetCaptainsMessage({ fr_id: eventId });
  const { mutate: updateCaptainsMessage, error } = useUpdateCaptainsMessage();
  const handleSendTeamMessage = () => {
    updateCaptainsMessage(
      {
        fr_id: eventId,
        captains_message: teamAnnouncementInputRef.current?.value as string,
      },
      {
        onSuccess: () => {
          onClose();
          toast({
            title: 'Team Announcement Sent',
            status: 'success',
            duration: 1000,
          });
        },
      }
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalTitle="Send a team announcement"
      hasFooter
      onSave={handleSendTeamMessage}
      onCancel={onClose}
    >
      <VStack px={2} spacing={4}>
        <Notification status="error" message={error?.message as string} />
        <Textarea
          ref={teamAnnouncementInputRef}
          h="115px"
          defaultValue={
            !isEmpty(captainsMessageData.data?.message)
              ? captainsMessageData.data?.message
              : ''
          }
          borderColor="brand.monochromatic.200"
          _hover={{ borderColor: 'none' }}
          _focus={{
            borderColor: 'brand.monochromatic.800',
            boxShadow: '0 0 0 4px var(--chakra-colors-brand-additional-focus)',
            opacity: 0.6,
          }}
        />
      </VStack>
    </Modal>
  );
};
